import { Dispatch, SetStateAction } from 'react'

import { Box } from '@chakra-ui/react'

import { StandardOperatingProceduresQuery } from '@/graphql/generated/operations'

import { RefetchSOPFnType } from '../types/types'
import { SOPsTable } from './SOPsTable'

interface ProceduresTabIProps {
  filter?: string
  onRowClick: (id: string) => void
  refetch: RefetchSOPFnType
  setFilter?: (value: string) => void
  sops?: StandardOperatingProceduresQuery
  pageIndex: number
  setPageIndex: Dispatch<SetStateAction<number>>
  pageSize: number
  setPageSize: Dispatch<SetStateAction<number>>
  sortColumn: string | null
  setSortColumn: Dispatch<SetStateAction<string | null>>
  sortOrder: 'asc' | 'desc' | null
  setSortOrder: Dispatch<SetStateAction<'asc' | 'desc' | null>>
  isLoading?: boolean
}

export const ProceduresTab = ({
  filter,
  onRowClick,
  refetch,
  setFilter,
  sops,
  pageIndex,
  setPageIndex,
  pageSize,
  setPageSize,
  sortColumn,
  setSortColumn,
  sortOrder,
  setSortOrder,
  isLoading,
}: ProceduresTabIProps) => {
  return (
    <Box overflow='hidden' pos='relative'>
      <Box
        h={{ base: 'calc(100vh - 175px)', md: 'calc(100vh - 138px)' }}
        overflow='scroll'
        overflowX='auto'
        px={{ md: 0, lg: 6 }}
        textAlign='center'
        transition='ease-in-out'
        transitionDuration='300ms'
        transitionProperty='all'
        w='full'
      >
        <SOPsTable
          filter={filter}
          isLoading={isLoading}
          onRowClick={onRowClick}
          pageIndex={pageIndex}
          pageSize={pageSize}
          refetch={refetch}
          setFilter={setFilter}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
          setSortColumn={setSortColumn}
          setSortOrder={setSortOrder}
          sops={sops}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
        />
      </Box>
    </Box>
  )
}
